import login from './login';

export default {
  language: 'ar-YE',
  country: 'ye',
  name: 'العربية',
  embeddedLocale: login,
};
